import { useNavigate } from 'react-router-dom';

import { InfoTeams } from './components/InfoTeams';
import { useGetTeams } from './hooks/useGetTeams';

import { Loader } from '@/components';
import { Layout } from '@/components/GenericsTournaments';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';

export const ViewRivalML: React.FC = () => {
  const { isMobile } = useIsDesktop();
  const navigate = useNavigate();
  const { tourneyData } = useTourney();

  const { isLoading, data } = useGetTeams(
    tourneyData.id,
    tourneyData.matchDay?.orden || 0,
    true
  );

  if (isMobile)
    return (
      <>
        <Loader isVisible={isLoading} />
        <Layout
          className="px-4 mt-4"
          main={() => (
            <div className="px-2 mt-6">
              <InfoTeams data={data} />
            </div>
          )}
          mobile={{
            centerContent: { title: 'Formación de equipo' },
            leftContent: {
              backAction: () => {
                navigate(ROUTES.minileagues.view);
              },
            },
          }}
        />
      </>
    );

  return null;
};
